module.exports = __webpack_public_path__ + "img/air_orange.41a96740.svg";